<template>
    <div style="background:#FAFAFA;" class="policeLato">
        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section v-if="isDesktop()">
            <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
                <p class="paralax-cover-image-text">
                <div class="content_home" style="z-index: 1!important;">
                    <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('rcscolaire.header[0]') }}</span></h1>
                    <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('rcscolaire.header[1]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>

        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section class="mt-5" v-if="isMobile()">
            <div class="paralax-cover-image_mobile has-background-dim_mobile">
                <p class="paralax-cover-image-text_mobile">
                <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                    <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('rcscolaire.header[0]') }}</span></h1>
                    <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('rcscolaire.header[1]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div>
            <div class="container" style="background:#FAFAFA">
                <div class="container justify-content-center row text-center mb-5 mt-5">
                    <p class="mb-3" style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">{{ $t('devis.devis_vie.sunuassur.title[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_vie.sunuassur.title[1]') }}</span>{{ $t('devis.devis_vie.sunuassur.title[2]') }} <span class="font-weight-bold">{{ $t('devis.devis_vie.sunuassur.title[3]') }}</span></p> <br>
                </div>
                <br>
                
                <div class="row" style="background:#FAFAFA" v-if="isDesktop()">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                                <div class="wizard-progress-with-circle">
                                    <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                                </div>
                                <div class="progress-bar-group">
                                    <div class="progress-bar-custom" id="testup"></div>
                                </div>
                                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                    <li class="step" id="firstStep">
                                        <div class="step-title">{{ $t('rcscolaire.devis.type_contrat') }}</div>
                                    </li>
                                    <li class="step" id="secondStep">
                                        <div class="step-title">{{ $t('rcscolaire.devis.infosDesktop') }}</div>
                                    </li>
                                  <li class="step" id="thirtStep">
                                    <div class="step-title">{{ $t('rcscolaire.devis.validation') }}</div>
                                  </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" style="background:#FAFAFA" v-if="isMobile()">
                    <div class="col-md-10" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                            <div class="wizard-progress-with-circle">
                                <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                            </div>
                            <div class="progress-bar-group">
                                <div class="progress-bar-custom" id="testup"></div>
                            </div>
                            <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                <li class="step" id="firstStep">
                                    <div class="step-title text-center mr-4">Type</div>
                                </li>
                                <li class="step" id="secondStep">
                                    <div class="step-title text-center mr-4">{{ $t('rcscolaire.devis.infosMobile') }}</div>
                                </li>
                              <li class="step" id="thirtStep">
                                <div class="step-title text-center mr-4">{{ $t('rcscolaire.devis.validation') }}</div>
                              </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>

                <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.lg.xl class="row mt-5" style="background:#FAFAFA">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">                           
                            <div class="page" v-show="step === 1">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepSimule" aria-hidden="true" aria-labelledby="step-StepSimule" class="wizard-tab-container">

                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="row">
                                                         <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="typeontrat" class="field-label">{{ $t('rcscolaire.devis.step_one.type_contrat') }}</label>
                                                                <select id="typeontrat" v-model="typeContrat" name="Step8" class="field-select">
                                                                    <option selected disabled>Sélectionner un type</option>
                                                                    <option value="INDIVIDUEL">Individuel (jusque 5 personnes)</option>
                                                                    <option value="GROUPE">Groupe (École, Association, etc.)</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="montant_formule" class="field-label">{{ $t('rcscolaire.devis.step_one.type_etablissement') }}</label>
                                                                <select @change="setFormuleCapitaux()" id="montant_formule" v-model="RcScolaire.School.type" name="Step8" class="field-select">
                                                                    <option selected disabled>{{$t('devis.devis_vie.sunuassur.firstStep.selection_formule_label')}}</option>
                                                                    <option v-for="items in RcScolaire.School.typeEtablissement" :key="items" :value="items">{{items}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row mt-3">
                                                         <div class="col-sm-6">
                                                                 <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nombre_eleve" class="field-label">{{ $t('rcscolaire.devis.step_one.nbre_eleve') }}</label>
                                                                <input @keypress="onlyNumber" v-model="RcScolaire.School.nombreEleve" placeholder="Saisir le nombre d'éléves" id="nombre_eleve" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                                 <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_etablissement" class="field-label">{{ $t('rcscolaire.devis.step_one.nom_etablissement') }}</label>
                                                                <input v-model="RcScolaire.School.nomEtablissement" placeholder="Saisir le nom de l'établissement" id="nom_etablissement" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 2">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepSimule" aria-hidden="true" aria-labelledby="step-StepSimule" class="wizard-tab-container">

                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                                 <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_representant" class="field-label">{{ $t('rcscolaire.devis.step_two.nom') }}</label>
                                                                <input v-model="RcScolaire.School.coordonne.nom" placeholder="Saisir le nom du représentant" id="nom_representant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                         <div class="col-sm-4">
                                                                 <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="number_representant" class="field-label">{{ $t('rcscolaire.devis.step_two.telephone') }}</label>
                                                                <input @keypress="onlyNumber" v-model="RcScolaire.School.coordonne.telephone" placeholder="Saisir le numéro du représentant" id="number_representant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                                 <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="email_representant" class="field-label">{{ $t('rcscolaire.devis.step_two.email') }}</label>
                                                                <input v-model="RcScolaire.School.coordonne.email" placeholder="Saisir l'adresse mail du représentant" id="email_representant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                    <button @click="backToFirstStep()" type="button" class="wizard-btn">
                                                        <span class="fas fa-arrow-left"></span>
                                                        {{ $t('devis.devis_auto.bouton_retour') }}
                                                    </button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button @click="schoolRepresentativeControl()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 3">
                                <div class="wizard-tab-content">
                                <div role="tabpanel" id="StepRecap" aria-labelledby="step-StepRecap" class="wizard-tab-container">
                                    <div>
                                    <div class="fields">
                                        <section class="section-sm-bottom-85">
                                        <div class="container mt-1">
                                            <div class="row gx-xxl-6">
                                            <div class="col-12 col-lg-12">
                                                <div class="row">
                                                <div class="col-12">
                                                    <div class="post">
                                                    <div class="post-body">
                                                        <div>
                                                        <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                                            <div class="form" style="border-radius: 20px;">
                                                            <div class="page">
                                                                <div class="wizard-tab-content">
                                                                <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.validationStep.title') }} :</div>
                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('rcscolaire.devis.step_three.type_contrat') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row ml-5 mr-5" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li class="subheading" style="list-style: none">{{ $t('rcscolaire.devis.step_three.type_contrat') }} :
                                                                                <span class="font-weight-bold to-right">{{ typeContrat }}</span>
                                                                            </li>
                                                                            <li class="subheading mt-2" style="list-style: none">{{ $t('rcscolaire.devis.step_three.type_etablissement') }} :
                                                                                <span class="font-weight-bold to-right">{{ this.RcScolaire.School.type }}</span>
                                                                            </li>

                                                                            <li class="subheading mt-2" style="list-style: none">{{ $t('rcscolaire.devis.step_three.nbre_eleve') }} :
                                                                                <span class="font-weight-bold to-right">{{ this.RcScolaire.School.nombreEleve }}</span>
                                                                            </li>

                                                                             <li class="subheading mt-2" style="list-style: none">{{ $t('rcscolaire.devis.step_three.nom_etablissement') }} :
                                                                                <span class="font-weight-bold to-right">{{ this.RcScolaire.School.nomEtablissement }}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>


                                                                     <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('rcscolaire.devis.step_three.infos_represebtant_label') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row ml-5 mr-5" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li class="subheading" style="list-style: none">{{ $t('rcscolaire.devis.step_three.nom') }}:
                                                                                <span class="font-weight-bold to-right">{{ this.RcScolaire.School.coordonne.nom }}</span></li>
                                                                            <li class="subheading mt-2" style="list-style: none">{{ $t('rcscolaire.devis.step_three.telephone') }} :
                                                                                <span class="font-weight-bold to-right">{{ this.RcScolaire.School.coordonne.telephone }}</span></li>

                                                                            <li class="subheading mt-2" style="list-style: none">{{ $t('rcscolaire.devis.step_three.email') }} :
                                                                                                                                           <span class="font-weight-bold to-right">{{ this.RcScolaire.School.coordonne.email }}</span>

                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    

                                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_auto.choix_assureurs') }}</p>
                                                      </div>
                                                    </div>

                                                    <div class="fields">
                                                      <div class="field-group row field-bank">
                                                        <div class="btn-choice col-sm-6 col-6" v-for="assure in listeAssureurs" :key="assure._id">
                                                      <input v-model="assureurs" type="checkbox" :value="assure.societe" :id="assure.societe"
                                                        class="field-input">
                                                      <label :for="assure.societe" class="field-label" :label="assure.societe">
                                                        <img :src="assure.logo" :alt="assure.societe" height="50">
                                                        <p class="field-title" style="margin-top:-3px;margin-bottom:-10px">{{ assure.societe }}</p>
                                                      </label>
                                                    </div>
                                                      </div>
                                                        </div>
                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.title') }}</p>
                                                                    </div>
                                                                    </div>

                                                                    <div class="ml-5 mr-5 row">
                                                                         <div class="col-sm-4">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper40" class="field-label">{{ $t('rcscolaire.devis.step_three.annee_scolaire') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input disabled :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance_placeholder')" v-model="RcScolaire.duree" id="Stepper40" name="Step11" class="field-input">
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-4">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper39" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_effet') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <date-picker id="Stepper39" :disabled-date="disabledAfterToday"  class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="RcScolaire.dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-4">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper40" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input disabled :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance_placeholder')" v-model="RcScolaire.dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                                <div class="wizard-card-footer clearfix ml-5 mr-5 mb-3">
                                                                 <div class="wizard-footer-left">
                                                    <button @click="backToSecondtStep()" type="button" class="wizard-btn">
                                                        <span class="fas fa-arrow-left"></span>
                                                        {{ $t('devis.devis_auto.bouton_retour') }}
                                                    </button>
                                                </div>
                                                                <div class="wizard-footer-right">
                                                                    <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                                                                        {{ $t('devis.devis_vie.sunuassur.bouton_valider_label') }}
                                                                    </button>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </section>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.sm.xs class="row mt-5" style="background:#FAFAFA">
                    <div class="col-md-10" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">                           
                            <div class="page" v-show="step === 1">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepSimule" aria-hidden="true" aria-labelledby="step-StepSimule" class="wizard-tab-container">

                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="row">
                                                         <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="typeontrat" class="field-label">{{ $t('rcscolaire.devis.step_one.type_contrat') }}</label>
                                                                <select id="typeontrat" v-model="typeContrat" name="Step8" class="field-select">
                                                                    <option selected disabled>Sélectionner un type</option>
                                                                    <option value="INDIVIDUEL">Individuel (jusque 5 personnes)</option>
                                                                    <option value="GROUPE">Groupe (École, Association, etc.)</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12 mt-3">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="montant_formule" class="field-label">{{ $t('rcscolaire.devis.step_one.type_etablissement') }}</label>
                                                                <select @change="setFormuleCapitaux()" id="montant_formule" v-model="RcScolaire.School.type" name="Step8" class="field-select">
                                                                    <option selected disabled>{{$t('devis.devis_vie.sunuassur.firstStep.selection_formule_label')}}</option>
                                                                    <option v-for="items in RcScolaire.School.typeEtablissement" :key="items" :value="items">{{items}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                          <div class="col-sm-12 mt-3">
                                                                 <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nombre_eleve" class="field-label">{{ $t('rcscolaire.devis.step_one.nbre_eleve') }}</label>
                                                                <input @keypress="onlyNumber" v-model="RcScolaire.School.nombreEleve" placeholder="Saisir le nombre d'éléves" id="nombre_eleve" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12 mt-3">
                                                                 <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_etablissement" class="field-label">{{ $t('rcscolaire.devis.step_one.nom_etablissement') }}</label>
                                                                <input v-model="RcScolaire.School.nomEtablissement" placeholder="Saisir le nom de l'établissement" id="nom_etablissement" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 2">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepSimule" aria-hidden="true" aria-labelledby="step-StepSimule" class="wizard-tab-container">

                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                                 <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_representant" class="field-label">{{ $t('rcscolaire.devis.step_two.nom') }}</label>
                                                                <input v-model="RcScolaire.School.coordonne.nom" placeholder="Saisir le nom du représentant" id="nom_representant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                         <div class="col-sm-12 mt-3">
                                                                 <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="number_representant" class="field-label">{{ $t('rcscolaire.devis.step_two.telephone') }}</label>
                                                                <input @keypress="onlyNumber" v-model="RcScolaire.School.coordonne.telephone" placeholder="Saisir le numéro du représentant" id="number_representant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12 mt-3">
                                                                 <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="email_representant" class="field-label">{{ $t('rcscolaire.devis.step_two.email') }}</label>
                                                                <input v-model="RcScolaire.School.coordonne.email" placeholder="Saisir l'adresse mail du représentant" id="email_representant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                    <button @click="backToFirstStep()" type="button" class="wizard-btn">
                                                        <span class="fas fa-arrow-left"></span>
                                                        {{ $t('devis.devis_auto.bouton_retour') }}
                                                    </button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button @click="schoolRepresentativeControl()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 3">
                                <div class="wizard-tab-content">
                                <div role="tabpanel" id="StepRecap" aria-labelledby="step-StepRecap" class="wizard-tab-container">
                                    <div>
                                    <div class="fields">
                                        <section class="section-sm-bottom-85">
                                        <div class="mt-1">
                                            <div class="row gx-xxl-6">
                                            <div class="col-12 col-lg-12">
                                                <div class="row">
                                                <div class="col-12">
                                                    <div class="post">
                                                    <div class="post-body">
                                                        <div>
                                                        <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                                            <div class="form" style="border-radius: 20px;">
                                                            <div class="page">
                                                                <div class="wizard-tab-content">
                                                                <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.validationStep.title') }} :</div>
                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('rcscolaire.devis.step_three.type_contrat') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li class="subheading" style="list-style: none">{{ $t('rcscolaire.devis.step_three.type_contrat') }} :
                                                                                <span class="font-weight-bold to-right">{{ typeContrat }}</span>
                                                                            </li>
                                                                            <li class="subheading mt-2" style="list-style: none">{{ $t('rcscolaire.devis.step_three.type_etablissement') }} :
                                                                                <span class="font-weight-bold to-right">{{ this.RcScolaire.School.type }}</span>
                                                                            </li>

                                                                            <li class="subheading mt-2" style="list-style: none">{{ $t('rcscolaire.devis.step_three.nbre_eleve') }} :
                                                                                <span class="font-weight-bold to-right">{{ this.RcScolaire.School.nombreEleve }}</span>
                                                                            </li>

                                                                             <li class="subheading mt-2" style="list-style: none">{{ $t('rcscolaire.devis.step_three.nom_etablissement') }} :
                                                                                <span class="font-weight-bold to-right">{{ this.RcScolaire.School.nomEtablissement }}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>


                                                                     <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('rcscolaire.devis.step_three.infos_represebtant_label') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li class="subheading" style="list-style: none">{{ $t('rcscolaire.devis.step_three.nom') }}:
                                                                                <span class="font-weight-bold to-right">{{ this.RcScolaire.School.coordonne.nom }}</span></li>
                                                                            <li class="subheading mt-2" style="list-style: none">{{ $t('rcscolaire.devis.step_three.telephone') }} :
                                                                                <span class="font-weight-bold to-right">{{ this.RcScolaire.School.coordonne.telephone }}</span></li>

                                                                            <li class="subheading mt-2" style="list-style: none">{{ $t('rcscolaire.devis.step_three.email') }} :
                                                                                                                                           <span class="font-weight-bold to-right">{{ this.RcScolaire.School.coordonne.email }}</span>

                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    

                                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_auto.choix_assureurs') }}</p>
                                                      </div>
                                                    </div>

                                                    <div class="fields">
                                                      <div class="field-group row field-bank">
                                                        <div class="btn-choice col-sm-6 col-6" v-for="assure in listeAssureurs" :key="assure._id">
                                                      <input v-model="assureurs" type="checkbox" :value="assure.societe" :id="assure.societe"
                                                        class="field-input">
                                                      <label :for="assure.societe" class="field-label" :label="assure.societe">
                                                        <img :src="assure.logo" :alt="assure.societe" height="50">
                                                        <p class="field-title" style="margin-top:-3px;margin-bottom:-10px">{{ assure.societe }}</p>
                                                      </label>
                                                    </div>
                                                      </div>
                                                        </div>
                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.title') }}</p>
                                                                    </div>
                                                                    </div>

                                                                    <div class="row">
                                                                         <div class="col-sm-12">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper40" class="field-label">{{ $t('rcscolaire.devis.step_three.annee_scolaire') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input disabled :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance_placeholder')" v-model="RcScolaire.duree" id="Stepper40" name="Step11" class="field-input">
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12 mt-3">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper39" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_effet') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <date-picker id="Stepper39" :disabled-date="disabledAfterToday"  class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="RcScolaire.dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12 mt-3">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper40" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input disabled :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance_placeholder')" v-model="RcScolaire.dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                                <div class="wizard-card-footer clearfix mb-3">
                                                                    <div class="wizard-footer-left">
                                                                        <button @click="backToSecondtStep()" type="button" class="wizard-btn">
                                                                            <span class="fas fa-arrow-left"></span>
                                                                            {{ $t('devis.devis_auto.bouton_retour') }}
                                                                        </button>
                                                                    </div>
                                                                    <div class="wizard-footer-right">
                                                                        <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                                                                            {{ $t('devis.devis_vie.sunuassur.bouton_valider_label') }}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </section>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>

        <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{$t('devis.devis_voyage.devis_encours')}}</span>
    </div>

         <div v-if="dialogLoadingFile" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('devis.devis_auto.flotte_entreprise.traitemant_label')}}</span>
      </div>

        <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
        <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
import Api from '../../services/Api'
import store from '../../store/store'
import LoginForm from '../auth/Login'
import AssurHospi from "./../../models/micro/Assurhospi"
import RcScolaire from "./../../models/rcscolaire/rcScolaire"
import checkRCInsurerConfig from "./../../common/checkRCInsurer.json"


    const validateEmail = email => {
        if (!email.length) {
            return {valide: false, error: "L'adresse mail est obligatoire!"};
        } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            return { valide: false, error: "Veuillez entrer un email valide!" };
        } else {
            return { valide: true, error: null };
        }
    };

    const validatePhone = phone => {

        if(!phone.length){
            return { valide: false, error: 'Le numéro de téléphone est obligatoire.' };
        }else if (phone.length < 9) {
            return { valide: false, error: 'Le numéro de téléphone doit contenir 9 chiffres au minimum.' };
        }else{
            return { valide: true, error: null };
        }

    };

    export default {
        name: 'Devis_sunuAssur',
        components: {
            LoginForm
        },
        data() {
            return {
                dialogLoadingFile : false,
                typeContrat : null,
                 listeAssureurs : [],
      assureurs: [],
                formule: null,
                nbmois: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                listecapitaux: [
                    {
                        capital: 100000,
                        hospitalisation: 150000,
                        prime: 340,
                    },
                    {
                        capital: 500000,
                        hospitalisation: 750000,
                        prime: 1700,
                    },
                    {
                        capital: 1000000,
                        hospitalisation: 1500000,
                        prime: 3400,
                    }

                ],
                Assurhospi: new AssurHospi(),
                RcScolaire: new RcScolaire(),

                choix : 'capital',
                dialogLoading : false,
                disabledButtonValidate : false,
                step: 1,
                dateSouscription: new Date().toISOString().substr(0, 10),
                neant: 'N.A',
                date: new Date().toISOString().substr(0, 10),
                first_questionnaire : true,
                isCapital : true,
                isRente : false,
                choixRente : null,
                oldDate : null,
                bottomPushNotif : false,
                disableDateAssure: true,
                Modalite : null,
                Assureur :'',
                money:{
                    thousands: ' ',
                    precision: false,
                    masked: false,
                },
                dateNaiss : null,
                duree : null,
                Capital:true,
                dateEffet: null,
                dateEcheance: null,
                e1: 1,
                elevation: 2,
                activeStep: 0,
                checkbox: false,
                errors: {},
                disable: false,
                valide: null,
                age: null,
                genre: null,
                branche: null,
                dialog: false,
                IsPaid: false,
                adresse: false,
                checked : false,
                showLoginForm: false,
                animation: 'animate-in',
                NomAssure: null,
                isContractant: true,
                isAssure: false,
                isBenef: false,
              
                isPayment : false,
              
                ToastTabSucess: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'error'
                }, // Customized options for error toast

                formSteps: [
                    {
                        title: "CONTRACTANT",
                        fields: [
                                    { valid: true },
                                ]
                    },
                    {
                        title: "ASSURE",
                        fields: [
                            { valid: true },
                               ]
                    },
                    {
                        title: "BENEFICIAIRE",
                        fields: [
                            { valid: true },
                                ]
                    },
                ],
            }
        },
        methods: {
            backToFirstStep(){
                this.step = 1
                document.getElementById("firstStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFirst');
            },

            backToSecondtStep(){
                this.step = 2
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthSecond');
            },

            filesChange(fileList) {
         if (!this.$store.state.isUserLoggedIn) {
              this.showLoginForm = true
          }else{
              if (!fileList.length) return;
      this.file = fileList[0];
      if(this.file){
          this.checkFlotteFile();
      }else {

      }
          }
    },
      checkFlotteFile() {
            if(this.file){
    //            const formData = new FormData();
    //   formData.append("excel", this.file);
    //   formData.append("userid", this.$store.state.user._id);
              this.dialogLoadingFile = true
              setTimeout(() => {
                this.dialogLoadingFile = false
                this.$toasted.show("Fichier des élèves uploadé avec succès !", this.ToastTabSucess)
                document.getElementById("secondStep").classList.add('checked');
                document.getElementById("secondStep").classList.add('widthSecond');
                this.step = 2
              }, 5000);
    //   Api()
    //     .post("tempflotte/add", formData, {
    //       headers: { "Content-Type": "multipart/form-data" },
    //     })
    //     .then((result) => {
    //       this.reference_flotte =  { id: result.data.vehicules[0].reference }
    //       this.tableData = result.data.vehicules;
    //         this.dialogLoadingFile = false
    //       if(this.tableData.length > 0){
    //         this.$toasted.show("Fichier Excel uploadé avec succès !", this.ToastTabSucess)
    //         this.ModalListeContrat = true
    //         this.clearInputFile()
    //       }else {
    //         this.clearInputFile()
    //         this.$toasted.show("Le fichier uploadé ne contient pas de véhicule!", this.ToastTabError)
    //       }
    //     })
    //     .catch((err) => {
    //       this.$toasted.show("Le format du fichier n'est pas reconnu!", this.ToastTabError)
    //       this.clearInputFile()
    //       this.dialogLoadingFile = false
    //     });
            }else {
              this.$toasted.show("Veuillez uploader un fichier pour continuer!", this.ToastTabError)
            }
             
    },

    clearInputFile(){
        const fileInput = document.querySelector('input[type="file"]');
  if (fileInput) {
    fileInput.value = '';
      // Reset related data
  //this.fileCount = 0;
  //this.tableData = [];
  }
    },
            /*=================Recuperation des partenaires assureurs==============*/
    getListePartenaire: function () {
        Api().get('partenaire/assureur')
            .then(response => {
            this.listeAssureurs = response.data.partenaires.filter(assureur => assureur.societe === 'SANLAMALLIANZ' || assureur.societe === 'NSIA' || assureur.societe === 'FINAFRICA');
            console.log("partenaires : ", this.listeAssureurs)
          })
      },
            setFormuleDureeCapitaux() {
            this.Assurhospi.prime = this.formule.prime * this.Assurhospi.duree

            },
            setFormuleCapitaux() {
                this.formule = this.listecapitaux.find(cap => cap.capital == this.Assurhospi.capital)
                this.Assurhospi.hospitalisation = this.formule.hospitalisation
                this.Assurhospi.prime = this.formule.prime
                this.Assurhospi.duree = 1
            },
            

            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
            let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
            if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                $event.preventDefault();
            }
            },
            /*================= retour à la premiere étape ==============*/
            returToFirstStep(){
                document.getElementById("firstStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFirst');
                this.step = 1
            },
            returToSecondStep(){
                this.activeStep -= 1;
                this.isContractant = true,
                this.isAssure = false
                this.step = 2
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthSecond');
            },
             /*================= retour à la troisieme étape ==============*/
            returToThirstStep(){
                this.activeStep -= 1;
                this.isContractant = false,
                this.isAssure = true
                this.isBenef = false
                this.step = 3
                document.getElementById("testup").classList.remove('widthThirt');
            },
             /*================= retour à la quatrieme étape ==============*/
             returToFourStep(){
                this.activeStep -= 1;
                this.isContractant = false,
                this.isAssure = false
                this.isBenef = true
                this.Questionnaire = false
                this.step = 4
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFour');
            },
              //Date object formater to String
            DateFormater: function (TheDate) {
            if (TheDate) {
                return dayjs(TheDate).format('DD-MM-YYYY')
            }
            },
            disabledBeforeToday(date) {
              const today = dayjs(this.dateDepart).add(+1, 'day')
              return date < today;
            },
            disabledAfterToday(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date < today;
            },
            disabledAfterTodayBirth(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date > today;
            },
         
            prev() {
                this.step--;
            },
            next() {
                this.step++;
            },

            /*===Send of data to API allowing create proposition for the customer===*/
            CreateDevis: function(){
                if (!store.state.isUserLoggedIn) {
                   this.showLoginForm = true
               } else {
                if(this.assureurs.length > 0){
                     if(this.RcScolaire.dateEffet){
                        const RCSCOLAIRE = {
                            duree : this.RcScolaire.duree,
                            branche: this.RcScolaire.branche,
                            assureurs:this.assureurs,
                            userid: store.state.user._id,
                            clientid: store.state.user._id,
                            createur: store.state.user._id,
                            dateEffet : dayjs(this.RcScolaire.dateEffet).format("YYYY-MM-DD"),
                            dateEcheance: this.RcScolaire.dateEcheance,
                            nom_etablissement : this.RcScolaire.School.nomEtablissement,
                            nom_prenom_representant : this.RcScolaire.School.coordonne.nom,
                            email_representant : this.RcScolaire.School.coordonne.email,
                            telephone_representant : this.RcScolaire.School.coordonne.telephone,
                            dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                            nombre_eleve: Number(this.RcScolaire.School.nombreEleve),
                            type_etablissement : this.RcScolaire.School.type,
                            plateforme:"Front",
                            FuturPaiement : null,
                        };
                        this.disabledButtonValidate = true
                        this.dialogLoading = true;

                        Api().post('rc-scolaire/add-devis', RCSCOLAIRE)
                            .then((result) => {
                                        console.log('::::::: devis obtenu : ',result.data)
                                        document.getElementById("testup").classList.add('widthSix');
                                            this.$store.dispatch('setDevis', result.data);
                                            this.dialogLoading = false, 
                                            this.disabledButtonValidate = false, 
                                            this.$router.push({ name: 'listDevis' })
                            }).catch((err) => {
                            console.log('error')
                        });
                        
                    }else {
                        this.$toasted.show( "Date d'effet obligatoire!", this.ToastTabError)
                    }
                }else {
                    this.$toasted.show( "Choisissez au moins un assureur !", this.ToastTabError)
                }
               }
           },

            DevisNextStep(){
                if(this.typeContrat){
                    if(this.typeContrat == 'INDIVIDUEL'){
                    if(this.RcScolaire.School.nombreEleve > 5){
                        this.$toasted.show("Nombre maximum d’élèves : 5 pour le contrat Individuel !", this.ToastTabError)
                    }else {
                          if(this.RcScolaire.School.type != null){
                        if(this.RcScolaire.School.nombreEleve){
                            if(this.RcScolaire.School.nomEtablissement) {
                                this.step = 2
                                document.getElementById("firstStep").classList.add('checked');
                                document.getElementById("testup").classList.add('widthFirst');
                            }else {
                                this.$toasted.show( "Nom de l'établissement obligatoire!", this.ToastTabError)
                            }
                        }else {
                            this.$toasted.show( "Nombre d'éléves obligatoire!", this.ToastTabError)
                        }
                    }else {
                        this.$toasted.show( "Type d'établissement obligatoire!", this.ToastTabError)
                    }
                    }
                } else if (this.typeContrat == 'GROUPE'){
                      if(this.RcScolaire.School.type != null){
                        if(this.RcScolaire.School.nombreEleve){
                            if(this.RcScolaire.School.nomEtablissement) {
                                this.step = 2
                                document.getElementById("firstStep").classList.add('checked');
                                document.getElementById("testup").classList.add('widthFirst');
                            }else {
                                this.$toasted.show( "Nom de l'établissement obligatoire!", this.ToastTabError)
                            }
                        }else {
                            this.$toasted.show( "Nombre d'éléves obligatoire!", this.ToastTabError)
                        }
                    }else {
                        this.$toasted.show( "Type d'établissement obligatoire!", this.ToastTabError)
                    }
                }

                }else {
                    this.$toasted.show( "Type de contrat obligatoire!", this.ToastTabError)
                }               
            },

            /**
             * Filtre les assureurs selon le nombre d'élèves et le type d'établissement
             * Chaque assureur a ses propres minimums par type d'établissement
             */
            filterInsurersByRules() {
                const studentCount = parseInt(this.RcScolaire.School.nombreEleve);
                const establishmentType = this.RcScolaire.School.type;
                const rules = checkRCInsurerConfig.filteringRules;
                
                let allowedInsurers = [];
                
                // SANLAMALLIANZ est toujours disponible (minimum 1 élève)
                if (studentCount >= rules.regleSpeciale.SANLAMALLIANZ.minStudents) {
                    allowedInsurers.push("SANLAMALLIANZ");
                }
                
                // Vérifier NSIA selon le type d'établissement et son minimum spécifique
                if (establishmentType && rules.regleSpeciale.NSIA.minStudentsByType[establishmentType]) {
                    const nsiaMinForType = rules.regleSpeciale.NSIA.minStudentsByType[establishmentType];
                    if (studentCount >= nsiaMinForType) {
                        allowedInsurers.push("NSIA");
                    }
                }
                
                // Vérifier FINAFRICA selon le type d'établissement et son minimum spécifique
                if (establishmentType && rules.regleSpeciale.FINAFRICA.minStudentsByType[establishmentType]) {
                    const finafricaMinForType = rules.regleSpeciale.FINAFRICA.minStudentsByType[establishmentType];
                    if (studentCount >= finafricaMinForType) {
                        allowedInsurers.push("FINAFRICA");
                    }
                }
                
                // Si aucun assureur ne correspond, utiliser les assureurs par défaut
                if (allowedInsurers.length === 0) {
                    allowedInsurers = checkRCInsurerConfig.defaultInsurers;
                }
                
                // Filtrer la liste des assureurs
                this.listeAssureurs = this.listeAssureurs.filter(assureur => 
                    allowedInsurers.includes(assureur.societe)
                );
                
                console.log(`Filtrage pour ${studentCount} élèves, type: ${establishmentType}`);
                console.log('Assureurs disponibles:', allowedInsurers);
                
                return allowedInsurers;
            },

        schoolRepresentativeControl(){
            if(this.RcScolaire.School.coordonne.nom != null){
                if(this.RcScolaire.School.coordonne.telephone){
                    if(this.RcScolaire.School.coordonne.email) {
                        let errors = {}
                        const validEmail = validateEmail(this.RcScolaire.School.coordonne.email);
                        errors.email = validEmail.error

                        if (validEmail.valide == true) {
                            // Appliquer le nouveau système de filtrage
                        const allowedInsurers = this.filterInsurersByRules();
                        
                        // Filtrer la liste des assureurs selon les règles
                        const partenaireFiltres = this.listeAssureurs.filter(partenaire => {
                            return allowedInsurers.includes(partenaire.societe);
                        });
                        
                        this.listeAssureurs = partenaireFiltres;
                             this.step = 3;
                        document.getElementById("secondStep").classList.add('checked');
                        document.getElementById("testup").classList.add('widthSecond');
                        } else {
                            this.$toasted.show( "Veuillez entrer un email valide!", this.ToastTabError)
                        }
                    }else {
                        this.$toasted.show( "Adresse email du représentant obligatoire!", this.ToastTabError)
                    }
                }else {
                    this.$toasted.show( "N° téléphone du représentant obligatoire!", this.ToastTabError)
                }
            }else {
                this.$toasted.show( "Nom complet du représentant obligatoire!", this.ToastTabError)
            }
        },

            
            toggleCheckbox() {
                if(this.checkbox == true){
                    this.Assurhospi.Assure.Nom = this.Assurhospi.Contractant.Nom
                    this.Assurhospi.Assure.Prenom = this.Assurhospi.Contractant.Prenom
                    this.Assurhospi.Assure.LieuNaissance = this.Assurhospi.Contractant.LieuNaissance
                    this.Assurhospi.Assure.Profession = this.Assurhospi.Contractant.Profession
                    this.Assurhospi.Assure.Adresse = this.Assurhospi.Contractant.Adresse
                    this.Assurhospi.Assure.Telephone = this.Assurhospi.Contractant.Telephone
                    this.Assurhospi.Assure.Email = this.Assurhospi.Contractant.Email
                    this.disableDateAssure = true
                    this.AssureControl()
                }else if(this.checkbox == false){
                    this.Assurhospi.Assure.dateNaissance = this.oldDate
                    this.dateNaiss = this.oldDate
                    this.ClearForm()
                }
            },
            ClearForm: function () {
                this.Assurhospi.Assure.Nom = null
                this.Assurhospi.Assure.Prenom = null
                //this.Assurhospi.Assure.dateNaissance = null
                this.Assurhospi.Assure.LieuNaissance = null
                this.Assurhospi.Assure.Profession = null
                this.Assurhospi.Assure.Adresse = null
                this.Assurhospi.Assure.Telephone = null
                this.Assurhospi.Assure.Email = null
                this.Assurhospi.Assure.LieuExe = null
            },
            yearsDiff(){
                const date1 = dayjs(this.dateNaiss).year();
                const date2 = new Date().getFullYear();
                let daydiff = date2 - date1
                this.age = daydiff;

                if (this.age <0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.dateNaiss = null
                } else if (this.age) {
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas être Supérieur à 18 ans! ", this.ToastTabError)
                        this.dateNaiss = null
                    }else if(this.age > 59){
                        this.$toasted.show( "L'année de naissance doit être inferieur à 60 ans!", this.ToastTabError)
                        this.dateNaiss = null
                    }
                }
                else if (this.age<=0) {
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.dateNaiss = null
                    }
                }
              
            },

            yearsDiffContractant() {
                const date1 = dayjs(this.Assurhospi.Contractant.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age <0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.Assurhospi.Contractant.dateNaissance = null

                } else if (this.age) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
                        this.Assurhospi.Contractant.dateNaissance = null
                    }
                }
                else if (this.age<=0) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
                        this.Assurhospi.Contractant.dateNaissance = null
                    }
                }
            },

            yearsDiffAssure() {
                const date1 = dayjs(this.Assurhospi.Assure.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.Assurhospi.Assure.dateNaissance = null


                } else if (this.age) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.Assurhospi.Assure.dateNaissance = null
                    }
                }  else if (this.age<=0) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.Assurhospi.Assure.dateNaissance = null
                    }
                }

            },

            // yearsDiffBenef() {
            //     const date1 = dayjs(this.Assurhospi.Beneficiaire.dateNaissance);
            //     const date2 = dayjs(new Date().toISOString().substr(0, 10));
            //     let daydiff = date2.diff(date1, 'days');
            //     this.age = daydiff;

            //     if (this.age < 0) {
            //         this.age = null;
            //         this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
            //         this.Assurhospi.Beneficiaire.dateNaissance = ""

            //     }
            // },


            BackToStep1(){
                //this.animation = 'animate-out-back';
                setTimeout(() => {
                    //this.animation = 'animate-in-back';
                    this.step = 1;
                   document.getElementById("firstStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFirst');
                }, 500);
            },

            BackToStep2(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.step = 3;
                    this.isContractant = false,
                        this.isAssure = true
                        this.isBenef = false
                }, 500);
            },

            BackToStep3(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 4;
                    this.isContractant = false,
                        this.isAssure = false
                    this.isBenef = true
                    this.Questionnaire = false
                }, 600);
            },
            BackToStep4(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 5;
                    this.isContractant = false,
                    this.isAssure = false
                    this.isBenef = false
                }, 600);
            },

            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },

            dateDiff: function () {
                if (this.RcScolaire.dateEffet) {
                let inter = dayjs(this.RcScolaire.dateEffet).add(this.RcScolaire.duree, "month").format("YYYY-MM-DD");
                this.RcScolaire.dateEcheance = dayjs(inter).add(-1, "day").format("YYYY-MM-DD");
            }
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isDesktop: function () {
                if (screen.width > 768) {
                    return true;
                } else {
                    return false;
                }
            },

            nextStep() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                    this.isAssure = true
                }, 600);
            },

            nextStep2() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                        this.isAssure = false,
                        this.isBenef =true
                }, 600);
            },

            nextStep3() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                    this.isAssure = false,
                    this.isBenef =false
                }, 600);
            },

            nextStep4() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                        this.isAssure = false,
                        this.isBenef =false,
                        this.isPayment = true
                }, 600);
            },


            ContractControl() {
                this.errors = {}
                if(this.Assurhospi.Contractant.Genre && this.Assurhospi.Contractant.Situation){
                    if (this.Assurhospi.Contractant.Nom && this.Assurhospi.Contractant.Prenom) {
                        if(this.Assurhospi.Contractant.dateNaissance && this.Assurhospi.Contractant.LieuNaissance){
                            if(this.Assurhospi.Contractant.Profession && this.Assurhospi.Contractant.Adresse){
                                if(this.Assurhospi.Contractant.Telephone && this.Assurhospi.Contractant.Email){
                                    const validPhone = validatePhone(this.Assurhospi.Contractant.Telephone);
                                    this.errors.phone = validPhone.error;

                                    const validEmail = validateEmail(this.Assurhospi.Contractant.Email);
                                    this.errors.email = validEmail.error;
                                    if(validEmail.valide == true && validPhone.valide == true){
                                        if(this.Assurhospi.Contractant.Cni){
                                            this.step = 3
                                            document.getElementById("testup").classList.add('widthSecond');
                                            document.getElementById("firstStep").classList.add('checked');
                                            this.nextStep();
                                        }else {
                                            this.$toasted.show('CNI obligatoire! ', this.ToastTabError)
                                            this.animation = 'animate-wrong';
                                            setTimeout(() => {
                                                this.animation = '';
                                            }, 400);
                                        }

                                    }
                                }else {
                                    this.$toasted.show('Téléphone et Email obligatoires! ', this.ToastTabError)
                                }
                            }else {
                                this.$toasted.show('Profession et Adresse obligatoires! ', this.ToastTabError)
                            }
                        }else {
                            this.$toasted.show('Date et Lieu de naissance obligatoires! ', this.ToastTabError)
                        }
                    } else {
                        this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
                    }
                }else {
                    this.$toasted.show('Genre et Situation obligatoires! ', this.ToastTabError)
                }

            },

            AssureControl() {
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                const date1 = dayjs(this.Assurhospi.Assure.dateNaissance);
                let daydiff = date2.diff(date1, "days");
                let yearAss = Math.floor(daydiff / 360);
                if (yearAss < 18 || yearAss > 59) {
                    this.$toasted.show("Date assuré doit etre dans l'interval 18 a 59 ans ! ", this.ToastTabError)
                    return;
                }
                
                this.errors = {}
                if (this.Assurhospi.Assure.Nom && this.Assurhospi.Assure.Prenom) {
                    if(this.Assurhospi.Assure.dateNaissance && this.Assurhospi.Assure.LieuNaissance){
                            if(this.Assurhospi.Assure.Telephone && this.Assurhospi.Assure.Email){
                                const validPhone = validatePhone(this.Assurhospi.Assure.Telephone);
                                this.errors.phone = validPhone.error;

                                const validEmail = validateEmail(this.Assurhospi.Assure.Email);
                                this.errors.email = validEmail.error;
                                if(validEmail.valide == true && validPhone.valide == true){
                                    if(this.Assurhospi.Assure.Cni){
                                        this.step = 4
                                        document.getElementById("testup").classList.add('widthThirt');
                                        document.getElementById("firstStep").classList.add('checked');
                                        this.nextStep2();
                                    }else {
                                        this.$toasted.show("CNI obligatoire! ", this.ToastTabError)
                                    }
                                }
                            }else {
                                this.$toasted.show('Téléphone et Email obligatoires! ', this.ToastTabError)
                                this.animation = 'animate-wrong';
                                setTimeout(() => {
                                    this.animation = '';
                                }, 400);
                            }
                       
                    }else {
                        this.$toasted.show('Date et lieu de naissance obligatoires! ', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
                }
            },

            // BenefControl() {
            //     if (this.Assurhospi.Beneficiaire.Nom && this.Assurhospi.Beneficiaire.Prenom) {
            //         if(this.Assurhospi.Beneficiaire.Filiation){
            //             const Date18 = dayjs(this.Assurhospi.Beneficiaire.dateNaissance).add(+18, 'year').format('YYYY-MM-DD')
            //             const dateToday = dayjs(new Date()).format('YYYY-MM-DD');

            //             const DateDiff = dayjs(dateToday).diff(dayjs(Date18), 'year')
            //             console.log("===== age beneficiaire=====", DateDiff)

            //             if(DateDiff <= 0){
            //                 this.step = 5
            //                 document.getElementById("testup").classList.add('widthFive');
            //                 document.getElementById("secondStep").classList.add('checked');
            //                 this.nextStep3()
            //             }else {
            //                 if(this.Assurhospi.Beneficiaire.Cni){
            //                     this.step = 5
            //                     document.getElementById("testup").classList.add('widthFive');
            //                     document.getElementById("secondStep").classList.add('checked');
            //                     this.nextStep3()
            //                 }else{
            //                     this.$toasted.show('Cni obligatoire! ', this.ToastTabError)
            //                 }
            //             }
            //         }else {
            //             this.$toasted.show('Filiation obligatoire! ', this.ToastTabError)
            //         }
            //     } else {
            //         this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
            //     }
            // },
            
            BackToBenefForm(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 4;
                    this.isContractant = false,
                    this.isAssure = false,
                    this.isBenef = true
                }, 500);
            },

            validField() {
                    if(this.question_7.principal_response === 'oui'){
                        if(this.question_7.resp_date){
                            this.QuestionnaireTab.push(this.question_7)
                            this.step = 6
                            document.getElementById("testup").classList.add('widthFive');
                            document.getElementById("thirtStep").classList.add('checked');
                            this.nextStep4()
                            this.bottomPushNotif =false
                        }else {
                            this.$toasted.show("Champ obligatoire! ", this.ToastTabError)
                        }
                    } else if (this.question_7.principal_response === 'non'){
                        this.QuestionnaireTab.push(this.question_7)
                        this.step = 6
                            document.getElementById("testup").classList.add('widthFive');
                            document.getElementById("thirtStep").classList.add('checked');
                        this.nextStep4()
                        this.bottomPushNotif =false
                    }
            }
        },
        mounted (){
             window.scrollTo(0, 0);
            this.getListePartenaire()
        }
    }
</script>

<style lang="less" scoped>
    @import "../../assets/css/button.css";
    @import "../../assets/css/devis_css.css";

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.to-right {
  float: right!important;
}


    .form {
        background-color: #fff;
        padding: 1.5rem;
    }

    .form .page {
        height: auto;
    }

    button.next {
        position: absolute;
        bottom: 0;
        right: 0;
        margin-right: 1.5rem;
        margin-bottom: 1rem;
    }

    button.previous {
        position: absolute;
        bottom: 0;
        left: 0;
        margin-left: 1.5rem;
        margin-bottom: 1rem;
    }


    button.edit {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    h4 {
        color: #29323a;
        margin-bottom: 15px;
        font-weight: 600;
    }




    html {
        background-color: #1a1a1a;
        overflow: hidden;
    }
    .middle {
        width: auto;
        text-align: center;
        /* Made by */
    }
    .middle h1 {
        font-family: "Inter", sans-serif;
        color: #fff;
    }
    .middle input[type="radio"] {
        display: none;
    }
    .middle input[type="radio"]:checked + .box {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
        color: #29323a;
    }
    .middle input[type="radio"]:checked + .box span {
        color: #29323a;
        transform: translateY(70px);
    }
    .middle input[type="radio"]:checked + .box span:before {
        transform: translateY(0px);
        opacity: 1;
    }
    .middle .box {
        width: 220px;
        height: 150px;
        border-radius: 12px;
        background-color: #fff;
        transition: all 250ms ease;
        will-change: transition;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        position: relative;
        box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
        font-size: 10px;
        border: 1px solid #d9dee3;
        font-family: Open Sans,sans-serif;
        font-weight: 900;
    }
    .middle .box:hover {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
    }
    .middle .box:hover span {
        color: #29323a;
    }

    .middle .box:active {
        transform: translateY(10px);
    }
    .middle .box span {
        position: absolute;
        transform: translate(0, 60px);
        left: 0;
        right: 0;
        padding-top: 15%;
        transition: all 300ms ease;
        font-size: 1.5em;
        user-select: none;
        color: #29323a;
    }
    .middle .box span:before {
        font-size: 1.2em;
        font-family: FontAwesome;
        display: block;
        transform: translateY(-80px);
        opacity: 0;
        transition: all 300ms ease-in-out;
        font-weight: normal;
        color: #fff;
    }
    .middle p {
        color: #fff;
        font-family: "Inter", sans-serif;
        font-weight: 400;
    }
    .middle p a {
        text-decoration: underline;
        font-weight: bold;
        color: #fff;
    }
    .middle p span:after {
        content: "\f0e7";
        font-family: FontAwesome;
        color: yellow;
    }

    .widthFirst{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:33%;
    }
    .widthSecond{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:65.11112%;
    }
    .widthThirt{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:40.11112%;
    }
    .widthFour{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:50.11112%;
    }
    .widthFive{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:65.11112%;
    }
    .widthSix{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:100%;
    }

    .paralax-cover-image {
        background-image: url('../../assets/img/assurance/assurPlus.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 230px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 40px;
    }



    .paralax-cover-image_mobile {
        background-image: url('../../assets/img/assurance/assurPlus_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        //padding: 20px;
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        //background-attachment: fixed;
        background-position: 100% 40px;
    }


    .hero {
        position: relative;
        background-size: cover;
        background-position: center center;
        height: 680px;
        min-height: 320px;
        max-height: 100%;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        align-items: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center;
        padding: 20px;
    }
    .hero .content_home {
        position: relative;
        min-height: 280px;
        width: 100%;
        margin-left: 8.5%;
        z-index: 2;
        /*//background: red;*/
    }
    .hero .content_home p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        width: 100%;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .to-left {
  text-align: left;
}

  // css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}

.drop-container {
  display:-webkit-box;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -ms-flex-direction:column;
  flex-direction:column;
  -webkit-box-pack:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -ms-flex-align:center;
  align-items:center;
  gap:10px;
  width:50%;
  padding:20px;
  border:2px dashed #000;
  border-radius:10px;
  background-color:#fefbf6;
  color:#000;
  cursor:pointer;
  -webkit-transition:background .2s ease-in-out,border .2s ease-in-out;
  transition:background .2s ease-in-out,border .2s ease-in-out
}
.drop-container:hover {
  background-color:#fbc162
}
.drop-title {
  color:#222245!important;
  font-size:20px;
  font-weight:700;
  text-align:center
}
.drop-subtitle {
  color:#222245!important;
  font-size:15px;
  font-weight:500;
  text-align:center
}
input[type=file] {
  width:350px;
  max-width:100%;
  color:#222245;
  padding:8px;
  background-color:#fff;
  border:1px solid #222245;
  border-radius:10px
}
input[type=file]:focus {
  outline-offset:2px
}
input[type=file]::file-selector-button {
  margin-right:8px;
  border:none;
  border-radius:10px;
  background-color:#f4ac39;
  padding:8px 12px;
  color:#000;
  font-size:15px;
  cursor:pointer
}
input[type=file]::file-selector-button:hover {
  background-color:#ffa409
}
</style>
